// src/js/components/Evaluation.js
import React, { Component } from "react";
import { connect } from "react-redux";

import Introduction from "./Evaluation/Introduction";
import Module from "./Evaluation/Module";
import Results from "./Evaluation/Results";
import ActionPlan from "./Evaluation/ActionPlan";
import ResultsDownloadForm from "./Evaluation/ResultsDownloadForm";

import './Evaluation/Evaluation.css';

const mapStateToProps = state => {
    return {
        modules: state.data.questionnaire.modules
    };
};

class ConnectedEvaluation extends Component {
    constructor(props) {
        super(props);
        this.displayModules = this.displayModules.bind(this);
    }

    displayModules(item, index) {
        return (
            <Module key={index} index={index} />
        )
    }

    render() {
        return (
            <div className="evQContainer">
                <Introduction />
                {this.props.modules.map((module,index) => this.displayModules(module, index))}
                <Results />
                <ActionPlan />
                <ResultsDownloadForm />
            </div>
        );
    }
}

const Evaluation = connect(mapStateToProps)(ConnectedEvaluation);

export default Evaluation;